import { useGlobalStore } from '~/stores/global';
import { useInteractiveStore } from '~/stores/interactive';

export default defineNuxtPlugin(() => {
  const interactiveStore = useInteractiveStore();
  const globalStore = useGlobalStore();
  const runtimeConfig = useRuntimeConfig();
  const isProd = runtimeConfig.public.isProd;
  if (
    interactiveStore.isPageSpeedBot ||
    !isProd ||
    globalStore.webview ||
    globalStore.isBot
  )
    return;
  window.rrPartnerId = '65706476c317ce21602213f0';
  window.rrApi = window?.rrApi || {};
  window.rrApiOnReady = window?.rrApiOnReady || [];

  function init() {
    const id = window.rrPartnerId;
    if (document.getElementById(id)) return;
    const script = document.createElement('script');
    script.src = '//cdn.retailrocket.ru/content/javascript/tracking.js';
    script.id = id;
    script.type = 'text/javascript';
    script.async = true;
    document.getElementsByTagName('head')[0].appendChild(script);
  }

  interactiveStore.addFunction(init);
});
